import styled from 'styled-components';

export const Container = styled.div`
	position: fixed;
	right: 0;
	top: 100px;
	padding: 30px;
	overflow: visible;
	pointer-events: none;
	z-index: 100000;
`;